import PPageContent from '../components/overallprogress/ProgressPageContent';

const HomeApp = () => {
  return <PPageContent />;
};

export default HomeApp;